import { CommonModule } from '@angular/common';
import { inject , Component, ChangeDetectionStrategy, signal } from '@angular/core';
import {
  DxCheckBoxModule,
  DxButtonModule,
  DxValidatorModule,
  DxValidationSummaryModule,
  DxValidationGroupModule,
  DxTemplateModule,
  DxLookupModule,
} from 'devextreme-angular';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { ClickEvent } from 'devextreme/ui/button';


import {
  Mandant,
  MandantenService,
} from './../../shared/services/mandanten.service';
import { AuthService } from './../../shared/services/core/auth/auth.service';

/**
 *
 */
@Component({
    selector: 'app-mandant',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        DxCheckBoxModule,
        DxButtonModule,
        CommonModule,
        DxValidatorModule,
        DxValidationSummaryModule,
        DxValidationGroupModule,
        DxTemplateModule,
        DxLookupModule,
    ],
    templateUrl: './mandant.component.html',
    styleUrl: './mandant.component.scss'
})
export class MandantComponent {
  
  
  private readonly mandantService = inject(MandantenService);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);
  public mandant$: Observable<Mandant[]> = this.mandantService.Store$;
  public readonly selectedMandantId = signal<number|null>(null);

  /**
   *
   * @param event
   */
  public saveData(event: ClickEvent) : void {
    
    const validationGroup = event.validationGroup;
    const validationResult = validationGroup?.validate();
    const mandantId = this.selectedMandantId();
    
    if (validationResult?.isValid && mandantId) {
      this.authService.MandantId = mandantId;

      if (this.authService.InitialRequestedUrl) {
        this.router.navigateByUrl(this.authService.InitialRequestedUrl);
        this.authService.InitialRequestedUrl = '';
        return;
      }
      this.router.navigate(['home']);
    }
  }
}
